export const month = ['Choose Month', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const gender = ['Male', 'Female']

export const employee = ['Full-Time', 'Subcontract', 'Trainee', 'Part-Time']

export const level = [
  { label: 'Choose Level', value: '' },
  { label: 'Junior', value: 'Junior' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Senior Consultant', value: 'Senior Consultant' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Asst. VP', value: 'Asst. VP' },
  { label: 'VP', value: 'VP' },
  { label: 'Director', value: 'Director' },
  { label: 'BOS', value: 'BOS' },
]

export const marital_status = [
  { label: 'Choose Status', value: '' },
  { label: 'Single', value: 'single' },
  { label: 'Married', value: 'married' },
  { label: 'Divorced', value: 'divorced' },
]

export const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'



// WEBPACK FOOTER //
// ./src/components/employee/constants.js